import type { HirerPaymentResult, PaymentStatus } from '../types';
import { PaymentGeneralError } from '../usecases/Errors/customErrors';

import { handleOrderErrorPayload } from './handleOrderError';

export async function submitInvoice(
  confirmInvoiceOrder: () => Promise<any>,
): Promise<HirerPaymentResult> {
  const onConfirmInvoiceOrder = await confirmInvoiceOrder();
  const onConfirmInvoiceOrderPayload =
    onConfirmInvoiceOrder?.data?.confirmInvoiceOrder;

  if (onConfirmInvoiceOrderPayload?.responseStatus === 'Accepted') {
    return {
      status: 'succeeded' as PaymentStatus,
      paymentMethod: 'Invoice',
    };
  }

  handleOrderErrorPayload(
    onConfirmInvoiceOrderPayload?.__typename,
    onConfirmInvoiceOrderPayload?.message,
  );

  throw new PaymentGeneralError(onConfirmInvoiceOrderPayload.message);
}
